import { Body1, Body1Strong, Button, Field, Spinner, Subtitle1, Title1, makeStyles, mergeClasses, shorthands } from '@fluentui/react-components';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  CheckmarkCircleFilled,
  DismissCircleFilled
  } from "@fluentui/react-icons";
import { useLocation, useHistory } from 'react-router-dom';
import { useMsal, useAccount } from '@azure/msal-react';
import { silentRequest } from '../../authConfig';
import axios from 'axios';

const homeStyles = {
    border: 0,
    margin: 0,
    width: '100%',
    minWidth: 'calc(100vw - 310px)',
    background: '#FAF9F8',
    position: 'relative',
  };

  function extractNumber(input) {
    const match = input.match(/\d+/);
    return match ? match[0] : null;
}

  const useStyles = makeStyles({
    root: {
        display: "flex",
        // backgroundColor: "#fff",
        flexDirection: "column",
        width: "425px",
    },
    detail: {
        // ...shorthands.border("2px", "solid", "#ccc"),
        // ...shorthands.overflow("hidden"),
        display: "flex",
        // height: "480px",
        backgroundColor: "#fff",
        ...shorthands.gap("20px"),
        justifyContent: "center",
        ...shorthands.padding("20px"),
        // ...shorthands.border("2px", "solid", "#ccc"),
        boxShadow: "rgba(0, 0, 0, 0.133) 0px 1.6px 3.6px 0px, rgba(0, 0, 0, 0.11) 0px 0.3px 0.9px 0px",
        ...shorthands.borderRadius("10px"),
    },
    userDetail: {
      // ...shorthands.border("2px", "solid", "#ccc"),
      ...shorthands.overflow("hidden"),
      display: "flex",
      width: "505px",
      ...shorthands.padding("20px"),
      ...shorthands.borderRadius("10px"),
      boxShadow: "rgba(0, 0, 0, 0.133) 0px 1.6px 3.6px 0px, rgba(0, 0, 0, 0.11) 0px 0.3px 0.9px 0px",
    },
    paymentDetail: {
      // ...shorthands.border("2px", "solid", "#ccc"),
      ...shorthands.overflow("hidden"),
      display: "flex",
      height: "400px",
      width: "319px",
      ...shorthands.padding("20px"),
      ...shorthands.borderRadius("10px"),
      boxShadow: "rgba(0, 0, 0, 0.133) 0px 1.6px 3.6px 0px, rgba(0, 0, 0, 0.11) 0px 0.3px 0.9px 0px",
    },
    flex: {
      display: "flex", 
      justifyContent: "end", 
      alignItems: "center",
      ...shorthands.gap("20px"),
    },
    flexLeft: {
      display: "flex", 
      justifyContent: "start", 
      alignItems: "center",
      ...shorthands.gap("5px"),
    },
    contentSpacing: {
      display: "flex", 
      alignItems: "center",
      ...shorthands.gap("5px"),
    },
    stack: {
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'nowrap',
      width: 'auto',
      height: 'auto',
      boxSizing: 'border-box',
      '> *': {
        textOverflow: 'ellipsis',
      },
      '> :not(:first-child)': {
        marginTop: '0px',
      },
      '> *:not(.ms-StackItem)': {
        flexShrink: 1,
      },
    },
    vertical: {
      display: 'flex',
      flexDirection: 'column',
    },
    fullWidth: {
      width: "100%"
    },
    spaceBetween: {
      justifyContent: "space-between"
    },
    columnGap: {
      ...shorthands.gap("0px", "10px"),
    },
    rowGap: {
      ...shorthands.gap("10px", "0px"),
    },
    horizontalCenter: {
      display: "flex",
      justifyContent: "center"
    },
    flexWrap: {
      display: "flex",
      flexWrap: "wrap"
    },
    width50Percent: {
      width: "40%",
      ...shorthands.margin("10px", "20px"),
      ...shorthands.borderBottom("2px", "solid", "black"),
    },
    horizontalSpaceBetween: {
      display: "flex",
      justifyContent: "space-between"
    },
  });

//   const slideDown = keyframes`
//   from {
//     transform: translateY(-100%);
//   }
//   to {
//     transform: translateY(0);
//   }
// `;

// const AnimatedRow = styled.tr`
//   border: 1px solid black;
//   padding: 8px;
//   animation: ${slideDown} 0.5s ease;
// `;

function makeDecimalNumber(num) {
  return num.toLocaleString(undefined, {
     maximumFractionDigits: 2,
     minimumFractionDigits: 2,
   })
 }

const API_URL = process.env.REACT_APP_API_URL;

const PaymentResult = () => {
    const styles = useStyles();

    const { t } = useTranslation();

    const { instance, accounts } = useMsal();
    const account = useAccount(accounts[0] || {});

    const location = useLocation();
    const history = useHistory();

    const [companyData, setCompanyData] = useState(null);

    const [transactionDetails, setTransactionDetails] = useState(null)

    const [manual, setManual] = useState(true)
    const [loading, setLoading] = useState(true)

    const [paidStatus, setPaidStatus] = useState("")

    const [getCompanyDetailSuccess, setGetCompanyDetailSuccess] = useState(false)
    
    useEffect(() => {
      if (getCompanyDetailSuccess) {
        setLoading(false)
      }
    }, [getCompanyDetailSuccess])

    async function fetchCompanyData() {
      // console.log('userEffect retrieve company and accounts data!');
  
      // const urlPath = window.location.pathname;
      // console.log('Body urlPath: ', urlPath);
  
      await instance
        .acquireTokenSilent({ ...silentRequest, account: account })
        .then((tokenResponse) => {
          // console.log('tokenResponse: ', tokenResponse);
  
          axios
            .get(API_URL + '/etax/companies', {
              headers: {
                Authorization: 'Bearer ' + tokenResponse.accessToken,
              },
            })
            .then(
              (response) => {
                // console.log(response);
  
                if (response.data.length === 0) {
                } else {
  
                  let _cid = ""
                  if (sessionStorage.getItem("companyId") && response.data.find(_company => _company.id === sessionStorage.getItem("companyId"))) {
                    setCompanyData(response.data.find(_company => _company.id === sessionStorage.getItem("companyId")));

                    // console.log(response.data.find(_company => _company.id === sessionStorage.getItem("companyId")))
                    // sessionStorage.setItem("companyId", response.data[0].id);
                    _cid = sessionStorage.getItem("companyId")
                  } else {
                    setCompanyData(response.data[0]);
                    sessionStorage.setItem("companyId", response.data[0].id);
  
                    _cid = response.data[0].id
                  }
  
                  axios
                      // .get(API_URL + '/companies-details/' + response.data[0].id, {
                      .get(API_URL + '/companies-details', {
                          headers: {
                              Authorization: 'Bearer ' + tokenResponse.accessToken,
                              'cid': _cid
                          },
                      })
                      .then((companiesDetailsResponse) => {
                          // console.log('companiesDetailsResponse: ', companiesDetailsResponse);
                          if (companiesDetailsResponse.data) {
                            if (companiesDetailsResponse.data.billings === undefined || companiesDetailsResponse.data.billings.manual === undefined || companiesDetailsResponse.data.billings.manual) {
                              setManual(true)
                              setLoading(false)

                              // history.push({
                              //   pathname: '/etax/documents/all',
                              //   state: {},
                              // });
                            } else {
                              setManual(false)
                            }

                            setGetCompanyDetailSuccess(true)
                          }
  
                      })
                      .catch((error) => {
                          console.log(error);
                      })
                   }
              },
              (error) => {
                console.log(error);
              }
            );
        })
        .catch((error) => {
          //Acquire token silent failure, and send an interactive request
          console.log(error);
          // instance.acquireTokenRedirect(silentRequest);
        });
  
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }

    // function getPaymentInquiry(_paymentResponse) {
    //   instance
    //   .acquireTokenSilent({ ...silentRequest, account: account })
    //   .then(async (tokenResponse) => {
    //     const response = await axios.get("http://localhost:7071/api/payments/2c2p/payment-inquiry", {
    //                         headers: {
    //                           Authorization: 'Bearer ' + tokenResponse.accessToken,
    //                           cid: companyId,
    //                         },
    //                         params: {..._paymentResponse, accessToken: tokenResponse.accessToken}
    //                       })

    //     console.log("response getPaymentInquiry", response)
    //     // if (!promptPay) {
    //     //   if (response.data.respCode === "0000") { 
    //     //     const paymentInquiry = response.data
    //     //     setPaidStatus("complete")
    //     //     setTransactionDetails({
    //     //       dateTime: paymentInquiry.transactionDateTime,
    //     //       invoiceNo: paymentInquiry.invoiceNo,
    //     //       amount: paymentInquiry.amount
    //     //     })
           
    //     //   } else { 
    //     //     setPaidStatus("fail")
    //     //   }
    //     // }

    //     setLoading(false)

    //   }).catch((error) => {
    //     //Acquire token silent failure, and send an interactive request
    //     console.log(error);
    //     // instance.acquireTokenRedirect(silentRequest);
    //   })
    // }

    const getQueryParam = (param) => {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(param);
    };

    async function initLocationProps(_location) {
      const locationProps = _location.state
      const locationSearch = _location.search

      // console.log("locationProps", locationProps)
      if (locationSearch) {
        // const query = new URLSearchParams(locationSearch);

        // const paymentResponse = query.get('paymentResponse');

        // if (paymentResponse) {
        //   getPaymentInquiry(paymentResponse)
        // } else {
        //   setPaidStatus("fail")
        // }

        
        const _status = getQueryParam("status")

        // const encodedMessage = getQueryParam('paymentResponse');
  
        // console.log("encodedMessage", encodedMessage)
        if (_status === "complete") {
          setPaidStatus("complete")

          const dateTime = getQueryParam("dateTime")
          const invoiceNo = getQueryParam("invoiceNo")
          const amount = getQueryParam("amount")

          setTransactionDetails({
            dateTime: dateTime,
            invoiceNo: invoiceNo,
            amount: amount
          })

          // setLoading(false)

          // getPaymentInquiry({ invoiceNo: invoiceNo})
          // const decodedMessage = base64URLDecode(encodedMessage);
          // const paymentResponse = JSON.parse(decodedMessage);
          
          // console.log("decodedMessage", decodedMessage)
          // console.log("paymentResponse", paymentResponse)
          // if (paymentResponse.respCode === "2000") {
          //   setPaidStatus("complete")
          //   // setTransactionDetails(locationProps.transactionDetails)
          //    getPaymentInquiry(paymentResponse, false)
          //  } else {
          //    setPaidStatus("fail")

          //    setLoading(false)
          //  }
        } else {
          setPaidStatus("fail")

          // setLoading(false)
        }

      } else {
        if (locationProps) {
          const _status = locationProps.status
  
          if (_status === "complete") {
            setPaidStatus("complete")

            const _invoiceNo = extractNumber(locationProps.transactionDetails.description)
            setTransactionDetails({...locationProps.transactionDetails, invoiceNo: _invoiceNo})
            // getPaymentInquiry({ invoiceNo: locationProps.invoiceNo})
          } else {
            setPaidStatus(_status)
          }
  
          // setLoading(false)
        } else {
          history.push({
            pathname: '/payments',
            state: {},
          });
        }
      }
      
    }

    useEffect(() => {
      fetchCompanyData()
      initLocationProps(location)
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function transactionDateTimeToThaiDate(_transactionDateTime) {
      const year = _transactionDateTime.substring(0, 4)
      const month = _transactionDateTime.substring(4, 6)
      const numOfDay = _transactionDateTime.substring(6, 8)
      const hour = _transactionDateTime.substring(8, 10)
      const minutes = _transactionDateTime.substring(10, 12)
      const second = _transactionDateTime.substring(12, 14)
      
      return `${numOfDay}/${month}/${year} ${hour}:${minutes}:${second} น.`;
    }

    const toThaiDateString = (isoDateTime) => {
      let date = '';
      date = new Date(isoDateTime);
      let year = date.getFullYear() + 543;
      let month = (date.getMonth() + 1).toString().padStart(2, '0');
      let numOfDay = date.getDate().toString().padStart(2, '0');
  
      let hour = date.getHours().toString().padStart(2, '0');
      let minutes = date.getMinutes().toString().padStart(2, '0');
      let second = date.getSeconds().toString().padStart(2, '0');
  
      return `${numOfDay}/${month}/${year} ${hour}:${minutes}:${second} น.`;
    };

    return <div style={homeStyles}>
      {manual ? (
        <div style={{ display: "flex", justifyContent: "center", marginTop: 21}}>
          {loading ? (
            <div style={{ display: "flex", alignContent: "center", height: "100%", width: "100%", justifyContent: "center"}}>
              <Spinner labelPosition="below" label={t(`paymentResult.loading`)} />
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column"}}>
              <div style={{ marginBottom: 21}}>
                <Subtitle1>{t(`paymentResult.thisPageCannotReach`)}</Subtitle1>
  
              </div>
              <div style={{ display: "flex", justifyContent: "center"}}>
                <Button 
                  appearance='primary' 
                  onClick={() =>  
                    history.push({
                      pathname: '/etax/documents/all',
                      state: {},
                    })}
                >
                  {t(`paymentResult.homepage`)}
                </Button>
                
              </div>
            </div>
          )}
        </div>
      ) : (
        <div style={{ display: "flex", justifyContent: "center"}}>
            <div className={styles.root}>
                <Title1 as='h1'>{t(`paymentResult.paymentResultHeader`)}</Title1>
                <div className={styles.horizontalCenter}>
                  <div className={styles.userDetail}>
                    {loading ? (
                      <div style={{ display: "flex", alignContent: "center", height: "100%", width: "100%", justifyContent: "center"}}>
                        <Spinner labelPosition="below" label={t(`paymentResult.loading`)} />
                      </div>
                    ) : (
                      <div className={mergeClasses(styles.vertical, styles.fullWidth, styles.columnGap)}>
                        {paidStatus === "complete" ? (
                          
                          <div className={mergeClasses(styles.vertical, styles.columnGap)}>
                            <div className={styles.horizontalCenter}>
                              <div className={styles.vertical}>
                                <div className={styles.horizontalCenter}>
                                  <CheckmarkCircleFilled color='green' fontSize={64} />
                                </div>
                                <div className={styles.horizontalCenter}>
                                  <Body1Strong>{t(`paymentResult.paymentResultComplete`)}</Body1Strong>
                                </div>
                                <div className={styles.horizontalCenter}>
                                  <Body1Strong>{transactionDateTimeToThaiDate(transactionDetails.dateTime)}</Body1Strong>
                                </div>
                              </div>

                            </div>
                            <br />
                            
                            <Field label={
                              <div className={styles.horizontalSpaceBetween}>
                                <label>{t(`paymentResult.invoiceNo`)}</label>
                                {transactionDetails.invoiceNo}
                              </div>
                            } ></Field>
                            <Field label={
                              <div className={styles.horizontalSpaceBetween}>
                                <label>{t(`paymentResult.user`)}</label>
                                <label>{companyData?.name || "-"}</label>
                              </div>
                            } ></Field>
                            
                            <Field label={
                              <div className={styles.horizontalSpaceBetween}>
                                <label>{t(`paymentResult.total`)}</label>
                                <label>{makeDecimalNumber(transactionDetails.amount)} {t(`paymentResult.baht`)}</label>
                              </div>
                            } ></Field>
                            {/* <Field label={
                              <div className={styles.horizontalSpaceBetween}>
                                <label>รอบบิล</label>
                                <label>01/03/2567 00:00:00 น. - 31/03/2567 23:59:59 น.</label>
                              </div>
                            } ></Field> */}
                            {/* <br /> */}
                            {/* <div className={styles.horizontalCenter}>
                              <div style={{ display: "flex", flexDirection: "column"}}>
                                <label>ทางเรากำลังจัดทำใบเสร็จรับเงิน/ใบกำกับภาษี</label>
                                <div className={styles.horizontalCenter}>
                                  <label>และจะส่งให้ทางอีเมลที่ระบุไว้</label>

                                </div>

                              </div>
                            </div> */}

                            <br />
                            
                            <div className={styles.horizontalCenter}>
                              <Button appearance="secondary" size='large' onClick={() => {
                                history.push({
                                  pathname: "/etax/documents/all",
                                  state: {},
                                });
                              }}>
                                {t(`paymentResult.homepage`)}
                              </Button>
                            </div>
                          </div>

                          
                        ) : (
                          <div className={mergeClasses(styles.vertical, styles.columnGap)}>
                            <div className={styles.horizontalCenter}>
                              <div className={styles.vertical}>
                                <div className={styles.horizontalCenter}>
                                  <DismissCircleFilled color='red' fontSize={64} />

                                </div>
                                <div className={styles.horizontalCenter}>
                                  <Body1Strong>{t(`paymentResult.paymentResultIncomplete`)}</Body1Strong>

                                </div>
                                <div className={styles.horizontalCenter}>
                                  <Body1Strong>{toThaiDateString(new Date().toISOString())}</Body1Strong>
                              

                                </div>
                              </div>

                            </div>
                            <br />
                            <div className={styles.horizontalCenter}>
                              <Body1>{t(`paymentResult.tryAgain`)}</Body1>
                            </div>
                            <br />
                            <div className={styles.horizontalCenter}>
                              <Button appearance="secondary" size='large' onClick={() => {
                                history.push({
                                  pathname: "/payments",
                                  state: {},
                                });
                              }}>
                                {t(`paymentResult.paymentPage`)}
                              </Button>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                    
                  </div>

                </div>
            </div>

        </div>
      )}
    </div>
};

export default PaymentResult;